import { apiClient } from '@/utils/api-client';

export interface QualityBreakdown {
  positive_count: number;
  negative_count: number;
  total_feedback: number;
}

export interface TrendPoint {
  month: string;
  conversations: number;
  unique_users: number;
  avg_messages_per_conversation: number;
}

export interface SkillUsageEntry {
  skill_name: string;
  count: number;
}

export interface DashboardStats {
  overview: {
    total_accounts: number;
    unique_users_this_month: number;
    unique_users_last_month: number;
    conversations_this_month: number;
    conversations_last_month: number;
    avg_messages_per_conversation: number;
  };
  trends: TrendPoint[];
  quality: QualityBreakdown;
  skills: {
    total: number;
    active: number;
    by_type: {
      interactive: number;
      template: number;
      passive: number;
    };
    by_execution_mode: {
      conversational: number;
      guided: number;
      deliverable: number;
    };
  };
  skill_usage: SkillUsageEntry[];
  knowledge_base: {
    domains: number;
    terminology_rules: number;
    agent_configs: number;
  };
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    return apiClient.get('/api/admin/llmops_dashboard');
  },
};
